import { render, staticRenderFns } from "./multiselect-field.vue?vue&type=template&id=234bf975&"
import script from "./multiselect-field.vue?vue&type=script&lang=js&"
export * from "./multiselect-field.vue?vue&type=script&lang=js&"
import style0 from "./multiselect-field.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports